import ProjectDetailsLayout from "@/components/layouts/ProjectDetailsLayout";
import PluginCard from "@/components/plugins/PluginCard";
import ActivityFeed from "@/components/project/activity/ActivityFeed";
import AggregateStats from "@/components/project/activity/AggregateStats";
import { ReactElement } from "react";

const Activity = () => {
    return (
        <div className="pt-12 pb-32 p-5 md:px-0">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-3xl font-medium mb-8 mt-4">Your Activity</h1>
                <div className="mt-6">
                    <AggregateStats />
                    <div className="mt-12 max-w-6xl mx-auto">
                        <ActivityFeed />
                    </div>
                </div>
            </div>
        </div>
    );
}

Activity.getLayout = function getLayout(page: ReactElement) {
    return <ProjectDetailsLayout>{page}</ProjectDetailsLayout>
}

export default Activity;